export default "__VITE_ASSET__xJML_Khf__"